import React, { useEffect, useRef, useState } from "react";
import PartyDetails from "./partyDetails";
import Datagrid from "./datagrid";
import { useDispatch, useSelector } from "react-redux";
import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from "../utility/Redux/modal";
import { useFocus } from "../utility/hooks/hooks";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import { selectToken } from "../utility/Redux/security";
import moment from "moment";
import CallAPI from "../utility/functions/getData";
import uniqueId from "uniqid";
import { useReactToPrint } from "react-to-print";
import AlertModalTwoButton from "../utility/component/modals/alertWithTwoButton";
import ItemMasterModal from "../masters/item-master/itemModal";
import PartyMasterCreaterModal from "../help/partyMasterCreaterModal";
import dataToLocal from "../utility/component/dataToLocal";
import deleteWholeDatabase from "../utility/functions/deleteWholeDatabase";
import IsLocalData from "../utility/component/isLocalData";
import { CallAPIPromise } from "../billing/common";
import { emptyRowDetails } from "./fun";
import IssuePrint from "./issuePrint";
import { IssueColumns } from "./columns";

const CreditNote = () => {
  const [itemMasterStatus, setItemMasterStatus] = useState(false);
  const muiTextBox = true;
  const [isClearForm, setIsClearForm] = useState(false);
  const [purchaseBillList, setPurcahseBillList] = useState([]);
  const [inputRef, setInputRefFoucs] = useFocus();
  const [partyNameRef, setPartyNameFocus] = useFocus();
  const [issueToRef, setIssueToRef] = useFocus();
  const [issuedByRef, setIssuedByRef] = useFocus();
  const [frieghtRef, setFrieghtFocus] = useFocus();
  const [barCodeListStatus, setBarCodeListStatus] = useState(false);
  const [barCodeList, setBarCodeList] = useState([]);
  const [debitNoteBillhelpStatus, setDebitNoteBillHelpStatus] = useState(false);

  const [partyMasterCreaterModalStatus, setPartyMasterCreaterModalStatus] =
    useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const handleClose = () => {
    setItemMasterStatus(false);
  };
  const printBarRef = useRef();
  const BillModeOption = [
    {
      name: "Bill",
      value: "Bill",
    },
    { name: "Cash", value: "Cash" },
  ];
  const TaxTypeOption = [
    {
      name: "EXCLUSIVE",
      value: "EXCLUSIVE",
    },
    { name: "INCLUSIVE", value: "INCLUSIVE" },
  ];

  const BillTypeOption = [
    {
      name: "Retail Purchase",
      value: "Retail Purchase",
    },
    { name: "GST Purchase", value: "GST Purchase" },
  ];
  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: "",
    msg: "",
    status: false,
    setStatus: "",
    button1: "",
    button1Click: "",
    button2: "",
    button2Click: "",
  });
  const defaultPartyDetails = {
    CREDIT_NOTE_NO: "",
    DATE: moment().format("YYYY-MM-DD"),
    NAME: "",
    ACCOUNT_NO: "",
  };
  const [partyDetails, setPartyDetails] = useState(defaultPartyDetails);

  const [purchaseRef, setPurchaseBillNoFocus] = useFocus();
  const [purchaseAmtRef, setPurcahseAmtFocus] = useFocus();
  const [partyRef, setPartyFocus] = useFocus();
  const [currentINVNO, setCurrentINVNO] = useState("");
  const [rows, setRows] = useState([
    {
      ...emptyRowDetails,
      id: uniqueId(),
    },
  ]);
  const [accountMasterHelpStatus, setAccountMasterHelpStatus] = useState(false);
  const currentDate = moment().format("YYYY-MM-DD");

  const dispatch = useDispatch();
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);

  const [duplicatePurchaseBill, setDuplicatePurcahseBill] = useState(false);

  const savePurchaseBill = () => {
    const itemRows = rows.filter(
      (item) => item.ICODE !== "" && item.ITEMNAME !== ""
    );
    const iTotal = itemRows.reduce(
      (acc, row) => acc + Number(row.QNTY * row.RATE),
      0
    );

    const updatedPartyDetails = itemRows.map((item) => {
      return {
        ...item,
        CREDIT_NOTE_NO: item.CREDIT_NOTE_NO ? item.CREDIT_NOTE_NO : "",
        DATE: partyDetails.DATE,
        TOTAL: iTotal.toFixed(2),
        GTOTAL: Number(
          itemRows
            .reduce((acc, row) => acc + Number(row.AMOUNT || 0), 0)
            .toFixed(2)
        ),
      };
    });

    const filterData = updatedPartyDetails;
    const invalidQuantityItems = filterData.filter((row) => {
      const quantity = Number(row.QNTY);
      return !Number.isFinite(quantity) || quantity <= 0;
    });

    if (!partyDetails.ACCOUNT_NO) {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "Please select an account.",
        })
      );
      setPartyFocus();
    } else if (!filterData.length) {
      setAlertTwoButtonModal((current) => ({
        ...current,
        title: "Alert",
        status: true,
        msg: "Please select at least one item.",
        button1: "Ok",
        button2: "",
        button1Click: () => {
          delayedFunction(rows[0].id);
          setAlertTwoButtonModal((modal) => ({
            ...modal,
            status: false,
          }));
        },
      }));
    } else if (invalidQuantityItems.length) {
      const itemNames = invalidQuantityItems
        .map((item) => item.ITEMNAME)
        .join(", ");
      setAlertTwoButtonModal((current) => ({
        ...current,
        title: "Invalid quantity",
        status: true,
        msg: `Enter a quantity greater than zero for: ${itemNames}.`,
        button1: "Ok",
        button2: "",
        button1Click: () => {
          setAlertTwoButtonModal((modal) => ({
            ...modal,
            status: false,
          }));
        },
      }));
    } else {
      setAlertTwoButtonModal((o) => {
        return {
          ...o,
          status: false,
        };
      });
      savePurchaseAfterCheck(
        prefix,
        filterData,
        partyDetails,
        dispatch,
        token,
        setCurrentINVNO,
        setAlertTwoButtonModal,
        clearState,

        handlePrint,
        setIsClearForm
      );
    }
  };

  const delayedFunction = (id) => {
    setTimeout(() => {
      // Function to execute after 30 seconds
      const nearestInput = document.getElementById(id + "-" + "ICODE");
      if (nearestInput) {
        nearestInput.focus();
      }
    }, 200);
  };

  const loadPurchaseBill = async (CREDIT_NOTE_NO) => {
    CallAPIPromise(
      "/api/creditNote/loadCreditNote",
      {
        table_prefix: prefix,
        CREDIT_NOTE_NO: CREDIT_NOTE_NO,
      },
      token
    )
      .then((p) => {
        const data = p.data.response.data;
        const res = data.map((h) => {
          return {
            ...h,
            DATE: moment(h.DATE).format("YYYY-MM-DD"),
            id: uniqueId(),
          };
        });

        if (res[0]) {
          setPartyDetails({
            CREDIT_NOTE_NO: res[0].CREDIT_NOTE_NO,
            DATE: moment(res[0].DATE).format("YYYY-MM-DD"),
            NAME: res[0].NAME,
            ACCOUNT_NO: res[0].ACCOUNT_NO,
          });
        }

        setRows([
          ...res,
          {
            ...emptyRowDetails,
            id: uniqueId(),
          },
        ]);
      })
      .catch((error) => {
        if (error.response.data.name === "TokenExpiredError") {
          dispatch(setSessionExpired(true));
        }
      });
  };

  const clearState = () => {
    setRows([
      {
        ...emptyRowDetails,
        id: uniqueId(),
      },
    ]);

    setPartyDetails(defaultPartyDetails);
  };

  const printRef = useRef();
  const thermalPrintRef = useRef();
  const [selectedPrintOption, setSelectedPrintOption] = useState("print");

  const handlePrint = useReactToPrint({
    pageStyle: `
    @page {
      size: portrait;
    }
  `,
    content: () =>
      selectedPrintOption === "print"
        ? printRef.current
        : thermalPrintRef.current,
    onAfterPrint: () => {
      clearState();
      // setAccountMasterHelpStatus(true);
      // setSelectedPrintOption("print");
    },
  });
  const handlePrint2 = useReactToPrint({
    pageStyle: `
    @page {
      size: portrait;
    }
  `,
    content: () =>
      selectedPrintOption === "print"
        ? printRef.current
        : thermalPrintRef.current,
    onAfterPrint: () => {
      // setAccountMasterHelpStatus(true);
      // setSelectedPrintOption("print");
    },
  });

  useEffect(() => {
    function handleKeyPress(event) {
      // Check if Ctrl or Alt key is pressed along with 'S'
      if ((event.ctrlKey || event.altKey) && event.key === "s") {
        event.preventDefault();
        savePurchaseBill();
      }
    }

    // Add event listener when component mounts
    window.addEventListener("keydown", handleKeyPress);

    // Remove event listener when component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [partyDetails, rows]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "1") {
        event.preventDefault();

        setPartyNameFocus();
        // Add your logic here
      }

      if (event.ctrlKey && event.key === "2") {
        event.preventDefault();
        delayedFunction(rows[0].id);
        // Add your logic here
      }

      if (event.ctrlKey && event.key === "3") {
        event.preventDefault();

        setFrieghtFocus();
        // Add your logic here
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (rows[0]?.ICODE && rows[0]?.ITEMNAME) {
      deleteWholeDatabase("credit_note").then(() => {
        dataToLocal("credit_note", rows, [
          {
            ...partyDetails,
            ICODE: 1,
          },
        ]);
      });
    }
  }, [rows]);

  useEffect(() => {
    const callback = (details, data) => {
      if (data[0]) {
        setAlertTwoButtonModal({
          title: "Unsaved Data",
          msg: "We found an unsaved Purchase. Do you want to load it?",
          status: true,
          button1: "Yes",
          button2: "Cancel",
          button1Click: () => {
            setPartyDetails(details[0]);
            setRows(data);
            setAlertTwoButtonModal((o) => {
              return {
                ...o,
                status: false,
              };
            });
          },

          button2Click: () => {
            deleteWholeDatabase("credit_note");
            setAlertTwoButtonModal((o) => {
              return {
                ...o,
                status: false,
              };
            });
          },
        });
      }
    };
    const elseFunc = () => {
      console.log("nothing");
    };
    IsLocalData("credit_note", callback, elseFunc);
  }, []);

  const width = useSelector(selectWidth);
  const data = {
    sellerInfo: {
      name: partyDetails.NAME,
      address: partyDetails.ADDRESS,
      gstin: partyDetails.TAX_NUMBER,
      phone: partyDetails.MOBILE,
    },
    invoiceDetails: {
      invoiceNo: partyDetails.PUR_BILL_NO,
      date: partyDetails.PUR_BILL_DATE,
      destination: "",
      gstin: partyDetails.TAX_NUMBER,
    },
    columns: IssueColumns(width, () => {}),
    items: [
      {
        description: "INTEL CORE I5",
        hsn: "8473",
        quantity: 1,
        unitRate: 17800.0,
        cgst: "9%",
        sgst: "9%",
        amount: 17800.0,
      },
      // Add other items here
    ],
    totals: {
      taxableAmount: "37,570.00",
      cgst: "2,865.51",
      sgst: "2,865.51",
      grandTotal: "37,570.00",
    },
  };
  return (
    <div className=" px-3 py-2 bg-[#f9fafc] h-full text-black text-sm overflow-y-auto">
      <PartyDetails
        currentDate={currentDate}
        BillModeOption={BillModeOption}
        TaxTypeOption={TaxTypeOption}
        BillTypeOption={BillTypeOption}
        partyDetails={partyDetails}
        setPartyDetails={setPartyDetails}
        duplicatePurchaseBill={duplicatePurchaseBill}
        setDuplicatePurcahseBill={setDuplicatePurcahseBill}
        dispatch={dispatch}
        rows={rows}
        setRows={setRows}
        issueToRef={issueToRef}
        setIssueToRef={setIssueToRef}
        issuedByRef={issuedByRef}
        setIssuedByRef={setIssuedByRef}
        refreshList={refreshList}
        partyNameRef={partyNameRef}
        muiTextBox={muiTextBox}
        debitNoteBillhelpStatus={debitNoteBillhelpStatus}
        accountMasterHelpStatus={accountMasterHelpStatus}
        setAccountMasterHelpStatus={setAccountMasterHelpStatus}
        loadPurchaseBill={loadPurchaseBill}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
        purchaseRef={purchaseRef}
        partyRef={partyRef}
        purchaseAmtRef={purchaseAmtRef}
        setPurcahseAmtFocus={setPurcahseAmtFocus}
        setPurchaseBillNoFocus={setPurchaseBillNoFocus}
        purchaseBillList={purchaseBillList}
        setPartyFocus={setPartyFocus}
        setInputRefFoucs={setInputRefFoucs}
        delayedFunction={delayedFunction}
        setPartyMasterCreaterModalStatus={setPartyMasterCreaterModalStatus}
      />
      <Datagrid
        delayedFunction={delayedFunction}
        savePurchaseBill={savePurchaseBill}
        inputRef={inputRef}
        setBarCodeListStatus={setBarCodeListStatus}
        setBarCodeList={setBarCodeList}
        setItemMasterStatus={setItemMasterStatus}
        partyDetails={partyDetails}
        setPartyDetails={setPartyDetails}
        setAccountMasterHelpStatus={setAccountMasterHelpStatus}
        rows={rows}
        setIsClearForm={setIsClearForm}
        setRows={setRows}
        currentINVNO={currentINVNO}
        clearState={clearState}
        handlePrint={handlePrint}
        handlePrint2={handlePrint2}
        alertTwoButtonModal={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
        setDebitNoteBillHelpStatus={setDebitNoteBillHelpStatus}
      />
      <ItemMasterModal
        status={itemMasterStatus}
        handleClose={handleClose}
        setRows={setRows}
        rows={rows}
        setItemMasterStatus={setItemMasterStatus}
      />
      <AlertModalTwoButton
        details={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />
      <PartyMasterCreaterModal
        afterCreate={() => {
          setPartyMasterCreaterModalStatus(false);
          setRefreshList((o) => !o);
        }}
        status={partyMasterCreaterModalStatus}
        hidePartyList={true}
        onClose={() => {
          setPartyMasterCreaterModalStatus(false);
        }}
      />

      <div
        style={{
          display: "none",
        }}
      >
        <div ref={printRef}>
          <IssuePrint
            data={data}
            partyDetails={partyDetails}
            rows={rows.filter((row) => row.ITEMNAME !== "")}
          />
        </div>
      </div>
    </div>
  );
};

export default CreditNote;
function savePurchaseAfterCheck(
  prefix,
  filterData,
  partyDetails,
  dispatch,
  token,
  setCurrentINVNO,
  setAlertTwoButtonModal,
  clearState,
  handlePrint,
  setIsClearForm
) {
  const data = {
    table_prefix: prefix,
    cart_credit_note: filterData,
    NEW_MODIFY: filterData[0].CREDIT_NOTE_NO ? "Modify" : "New",
  };
  {
    partyDetails.CREDIT_NOTE_NO
      ? dispatch(setSpinnerLoading("Updating"))
      : dispatch(setSpinnerLoading("Saving"));
  }
  CallAPI(
    "/api/creditNote/saveCreditNote",
    data,
    token,
    (e) => {
      if (!e.data.error) {
        deleteWholeDatabase("credit_note");
        setCurrentINVNO(e.data.CREDIT_NOTE_NO);
        const CREDIT_NOTE_NO = e.data.CREDIT_NOTE_NO;
        setAlertTwoButtonModal((e) => {
          return {
            ...e,
            title: partyDetails.CREDIT_NOTE_NO
              ? `Credit Note - ${partyDetails.CREDIT_NOTE_NO} `
              : `Credit Note - ${CREDIT_NOTE_NO}`,
            msg: "Data Saved",
            status: true,
            button1: "Ok",
            button1Bg: "gray",

            button2Bg: "#34b4eb",
            button2: "Print",
            button1Click: () => {
              setAlertTwoButtonModal((e) => {
                return {
                  ...e,
                  status: false,
                };
              });

              clearState();
            },
            button2Click: () => {
              setAlertTwoButtonModal((e) => {
                return {
                  ...e,
                  status: false,
                };
              });
              setIsClearForm(true);
              handlePrint();
            },
          };
        });
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
}
